module.exports = __webpack_public_path__ + "images/application/i-add-fill-47cc0327.svg";